import {
  SET_CLAIM_MEMBERS,
  SET_CLAIMS_SUMMARY_FOR_SELECTED_MEMBER,
  SET_CLAIM_DETAILS_FOR_CLAIM,
  SET_PAYMENT_DETAILS_FOR_CLAIM_AND_INVOICE,
  SET_FAST_TRACK_APPOINTMENTS,
  SET_PAYMENT_DETAILS_FOR_NOTIFICATION,
  SET_MEMBER_DETAIL,
  SET_CLAIMS_CONDITION
} from "./../../actions/claims/claimsActions";
import { SET_SELECTED_POLICY } from "../../actions/policy/policyActions";
import clone from "clone";

const initialState = {
  policies: [],
  selectedPolicy: {
    MembershipNumber: null,
    claimMembers: [],
    selectedClaimMember: null,
    selectedClaim: null,
    SFMemberDetails:null,
    selectedInvoice: null,
    appointments: null,
    SFclaimCondition:null,
    navigatedFromNotification: false
  }
};

export default function claimsReducer(state = initialState, action) {
  let copiedState = clone(state);

  if (action.type === SET_SELECTED_POLICY) {
    let selectedPolicy = copiedState.policies.find(
      m => m.MembershipNumber === action.payload.MembershipNumber
    );
    if (!selectedPolicy) {
      copiedState.policies.push({
        MembershipNumber: action.payload.MembershipNumber,
        claimMembers: [],
        selectedClaimMember: null,
        selectedClaim: null,
        selectedInvoice: null,
        appointments: null
      });
      selectedPolicy = copiedState.policies.find(
        m => m.MembershipNumber === action.payload.MembershipNumber
      );
    }
    copiedState.selectedPolicy.navigatedFromNotification = false;
    copiedState.selectedPolicy.selectedClaim = null;
    copiedState.selectedPolicy.selectedInvoice = null;
    copiedState.selectedPolicy = selectedPolicy;
  } else if (action.type === SET_CLAIM_MEMBERS) {
    copiedState.selectedPolicy.claimMembers = action.payload;
    copiedState.selectedPolicy.selectedClaimMember = null;
  } else if (action.type === SET_CLAIMS_SUMMARY_FOR_SELECTED_MEMBER) {
    copiedState.selectedPolicy.selectedClaimMember = findSelectedMember(
      action.payload.SecurityId,
      copiedState.selectedPolicy.claimMembers
    );
    copiedState.selectedPolicy.selectedClaimMember.Conditions =
      action.payload.Conditions;
    copiedState.selectedPolicy.selectedClaim = null;
    copiedState.selectedPolicy.selectedInvoice = null;
  } else if (action.type === SET_CLAIM_DETAILS_FOR_CLAIM) {
    copiedState.selectedPolicy.selectedClaimMember = findSelectedMember(
      action.payload.selectedMember.SecurityId,
      copiedState.selectedPolicy.claimMembers
    );

    copiedState.selectedPolicy.selectedClaim = copiedState.selectedPolicy.selectedClaimMember.Conditions.find(
      m => m.ClaimNumber && m.ClaimNumber === action.payload.selectedClaimNumber
    );

    copiedState.selectedPolicy.selectedClaim.ClaimDetails = action.payload.selectedMember.Conditions.find(
      m => m.ClaimNumber && m.ClaimNumber === action.payload.selectedClaimNumber
    ).ClaimDetails;
    copiedState.selectedPolicy.selectedInvoice = null;
  } else if (action.type === SET_PAYMENT_DETAILS_FOR_CLAIM_AND_INVOICE) {
    copiedState.selectedPolicy.selectedClaimMember = findSelectedMember(
      copiedState.selectedPolicy.selectedClaimMember.SecurityId,
      copiedState.selectedPolicy.claimMembers
    );

    copiedState.selectedPolicy.selectedInvoice = copiedState.selectedPolicy.selectedClaim.ClaimDetails.Invoices.find(
      i =>
        i.PartialInvoiceReference ===
        action.payload.InvoiceReference.split("/")[1]
    );

    copiedState.selectedPolicy.selectedInvoice.PaymentDetails = action.payload;
    copiedState.selectedPolicy.navigatedFromNotification = false;
  } else if (action.type === SET_FAST_TRACK_APPOINTMENTS) {
    copiedState.selectedPolicy.appointments = action.payload;
  } else if (action.type === SET_PAYMENT_DETAILS_FOR_NOTIFICATION) {
    copiedState = initialState;
    copiedState.selectedPolicy.selectedInvoice = {
      PaymentDetails: action.payload.paymentDetails,
      IsPaymentNeededByMember: action.payload.isPaymentNeededByMember,
      TreatingProviderName: action.payload.paymentDetails.TreatingProviderName,
      ProviderInvoiceReference:
        action.payload.paymentDetails.ProviderInvoiceReference
    };
    copiedState.selectedPolicy.selectedClaim = {
      ClaimNumber: action.payload.paymentDetails.ClaimReference,
      ClaimCondition: action.payload.paymentDetails.ClaimCondition
    };
    copiedState.selectedPolicy.navigatedFromNotification = true;
  }else if(action.type === SET_MEMBER_DETAIL)
  {
   copiedState.selectedPolicy.SFMemberDetails = {
    memberplanId : action.payload.MemberPlanId,
    memberDetails: action.payload,
   };
  }
  else if(action.type === SET_CLAIMS_CONDITION){
   copiedState.selectedPolicy.SFclaimCondition = action.payload.HealthConditions;
  }

  return copiedState;
}

function findSelectedMember(securityId, members) {
  return members.find(m => m.SecurityId && m.SecurityId === securityId);
}
